import talksData from '../data/talks.json';
import { Talk } from '../models/talk.interface';

export class TalksService {
    private talks: Talk[] = [];

    constructor() {
        this.talks = talksData.talks as Talk[];
    }

    getTalks(): Talk[] {
        return this.talks;
    }

    groupByYear(): Map<number, Talk[]> {
        const grouped = new Map<number, Talk[]>();
        this.talks.forEach(talk => {
            const existing = grouped.get(talk.year) || [];
            existing.push(talk);
            grouped.set(talk.year, existing);
        });
        const sorted = Array.from(grouped.entries()).sort((a, b) => b[0] - a[0]);
        return new Map(sorted);
    }
}

export const talksService = new TalksService();
